import React, { createContext, Children, isValidElement, cloneElement } from 'react';
import { css } from '@styled-system/css';
import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const buttonsStyles = (isStacked) => {
  if (isStacked) {
    return {
      "button:not(:first-child)": {
        marginTop: -1,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0
      },
      "button:not(:last-child)": {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
      }
    };
  }
  return {
    "button:not(:first-child)": {
      marginLeft: -1,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    },
    "button:not(:last-child)": {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    }
  };
};
const StyledToggleButtonGroup = styled(Box)((props) => css(__spreadValues({
  width: props.isFull ? "100%" : "auto",
  display: "flex",
  flexDirection: props.isStacked ? "column" : "row",
  button: {
    flex: "1 1 auto"
  }
}, buttonsStyles(props.isStacked))));
const ToggleButtonGroupContext = createContext({ value: void 0 });
const ToggleButtonGroup = forwardRef((_a, ref) => {
  var _b = _a, { children, onChange, value, size, isRounded = false, isFull = false, isStacked = false, isDisabled } = _b, props = __objRest(_b, ["children", "onChange", "value", "size", "isRounded", "isFull", "isStacked", "isDisabled"]);
  const handleChange = (event, value2) => {
    onChange == null ? void 0 : onChange(event, value2);
  };
  return /* @__PURE__ */ React.createElement(ToggleButtonGroupContext.Provider, {
    value: { value }
  }, /* @__PURE__ */ React.createElement(StyledToggleButtonGroup, __spreadValues({
    ref,
    isFull,
    isStacked
  }, props), Children.map(children, (child) => {
    if (!isValidElement(child)) {
      return null;
    }
    return cloneElement(child, {
      size: child.props.size || size,
      isRounded: child.props.isRounded || isRounded,
      isDisabled: child.props.isDisabled || isDisabled,
      onChange: handleChange
    });
  })));
});
ToggleButtonGroup.displayName = "ToggleButtonGroup";

export { ToggleButtonGroup, ToggleButtonGroupContext };
//# sourceMappingURL=ToggleButtonGroup.es.js.map
